import { apiGet } from '../../API/httpCommon';
import { useEffect, useState } from 'react';
import { ProductModel } from '../../Model/ProductModel';
import config from '../../config.json';
import { debug } from 'console';
import Spinner from '../Spinner/Spinner';
import {AddUpdateCart,GetCart} from  '../../Utility/CartUtility';
import { useLocation } from 'react-router-dom';


const Search = (props : any) =>{
	const [ProductList, setProductList] = useState<ProductModel[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const[Startindex,setStartindex] = useState(0);
	const[Pagesize,setPagesize] = useState(40);

	const [SearchText, setSearchText] = useState('');

    const location = useLocation();

	useEffect(function () {
    
		const queryParams = new URLSearchParams(location.search);
		const strm : any = queryParams.get('strm');
		setSearchText(strm);
        getSearchList(strm,Startindex,Pagesize);
        const userAgent = navigator.userAgent;
    }, [location.search]);

    

	const getSearchList = (_SearchText : any,  Startindex : any , Pagesize : any) => {
		
        setIsLoading(true);
        if(_SearchText !== SearchText){
            Startindex = 0;
        }
        apiGet("api/Search/SearchList?SearchText="+_SearchText +"&Startindex="+Startindex + "&Pagesize="+Pagesize).then((res: any) => {
		
            if(_SearchText !== SearchText){
                Startindex = 0;
                setProductList(res?.Data);
            }
            else{
		    	setProductList(prevData => [...prevData, ...res?.Data]);
            }
			setStartindex(Startindex+1);
          //  setProductList(res?.Data);
            setIsLoading(false);
        });
    }


	const addToCart = (actionType : any, _Item_Id : any, _Item_Title : any, _Quantity : any, _Seller_Price : any, _Seller_Id : any, _Item_Title_Url : any) =>{
		const response  =  AddUpdateCart(actionType , _Item_Id , _Item_Title , _Quantity , _Seller_Price, _Seller_Id,0, _Item_Title_Url);
		 $("#CartText").text(GetCart().length);
  
 	}

 	const ViewMore = () =>{
		getSearchList(SearchText,Startindex,Pagesize);
	}



    return(<>
  {(isLoading && <Spinner></Spinner>)} 
  <div className=" breadcrumb-padding-180"></div>
    <section className="shop-section fix section-padding">
        <div className="container">
            <div className="shop-default-wrapper">
                <div className="row">

                    <div className="col-xl-12 col-lg-12 col-md-12  order-1 order-md-2">
                           
                                <div className="row">


								{ProductList?.map(item => (

                                    <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s">
                                       <div className="shop-box-items style-2">
											<div className="book-thumb center">
												<a href={"/" + item?.Item_Title_Url + "-" + item?.Item_Id}><img src={config?.ThumbImageBaseUrl + item?.Image_Link} alt="img" /></a>
											   
											</div>
											<div className="shop-content">
												<h3><a href="#">{item?.Item_Title}</a></h3>
										  	 {(item?.Release_Date &&	<h5> Publish Year: {item?.Release_Date} </h5> )}
												<ul className="price-list">
                                                <li>Price: {item?.Seller_Price}</li>
                                                <li>
                                                    <del>₹ {item?.Base_Price}</del>
                                                </li>
                                            </ul>
											</div>
										<div className="shop-button">

                                            

                                                {
                                                    (item?.Stock_Status === "PreOrder" || item?.Stock_Status === "In Stock" ||
                                                        item?.Stock_Status === "In Stock" || item?.Stock_Status === "Avaliable") && (
                                                        <>
                                                            <a className="theme-btn crtbtn" onClick={() => addToCart('Add', item?.Item_Id, item?.Item_Title, 1, item?.Seller_Price, item.Seller_Id, item?.Item_Title_Url)} ><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                                            <a onClick={() => addToCart('Add', item?.Item_Id, item?.Item_Title, 1, item?.Seller_Price, item.Seller_Id, item?.Item_Title_Url)} className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>

                                                        </>)
                                                }

                                                {
                                                    (item?.Stock_Status === "Permanently Discountinued" || item?.Stock_Status === "Termprory Unavailable" ||
                                                        item?.Stock_Status === "Out of Stock") && (
                                                        <>
                                                            <span>{item?.Stock_Status}</span>
                                                        </>)
                                                }


                                        </div>

										</div>
                                    </div>
								))}
									
                                    {
                                        (ProductList === undefined || ProductList === null || ProductList.length === 0) && <>
                                        <span>Sorry, No Results Found for "{SearchText}"</span>
                                        </>
                                    }

                                </div>
                       
                        <div className="page-nav-wrap text-center">
                            <ul>
                                <li><a className="previous" onClick={ViewMore} >View More</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* </div> */}
    </section>

    </>);

}


export default Search;